import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { MaterializeAction } from "angular2-materialize"
import { Subscription } from 'rxjs';
import { Noticia } from '../../model/noticia';
import { NoticiasService } from './noticias.service';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {

  carouselActions = new EventEmitter<string | MaterializeAction>();
  sub: Subscription;
  noticias: any = [];
  link = "parnamirim.rn.gov.br";

  constructor(private noticiasService: NoticiasService) { 
  }

  ngOnInit() { 
    this.grade();
  }

  grade() {
    this.noticiasService.listarNoticias()
    .subscribe(
      data => {  
        this.noticias = (data);
    });
  }


}


// WEBPACK FOOTER //
// ./src/app/portal-cmcti/noticias/noticias.component.ts